export const legacyAuthRouteMap: Record<string, string> = {
  '/auth/login': 'sign-in',
  '/auth/sign-up': 'sign-up',
  '/auth/restore-password': 'reset-password',
  '/auth/password-recovery': 'set-new-password',
  '/auth/direct-inv': 'sign-up',
  '/inv': 'sign-up',
};

export const getLegacyAuthRedirectUrl = (
  pathname: string,
  search: string,
  defaultLocale: string
): string => {
  const targetRoute = legacyAuthRouteMap[pathname] || 'sign-in';
  const searchParams = new URLSearchParams(search);

  if (pathname === '/auth/direct-inv') {
    const invitationToken = searchParams.get('inv');

    if (invitationToken && !searchParams.has('direct-inv')) {
      searchParams.set('direct-inv', invitationToken);
    }

    if (invitationToken) {
      searchParams.delete('inv');
    }
  }

  const queryString = searchParams.toString()
    ? `?${searchParams.toString()}`
    : '';

  return `/${defaultLocale}/${targetRoute}${queryString}`;
};
